import React from 'react';
import { Checkbox } from '..';

function RowSelectionCheckbox({ indeterminate, checked: customChecked, onChange, disabled = false }) {
  const [checked, setChecked] = React.useState(customChecked);
  React.useEffect(() => {
    if (indeterminate) {
      setChecked(true);
    } else {
      setChecked(customChecked);
    }
  }, [customChecked, indeterminate]);

  return (
    <Checkbox
      checked={checked}
      onChange={(checked) => onChange({ target: { checked: checked } })}
      indeterminate={indeterminate}
      disabled={disabled}
    />
  );
}

export default RowSelectionCheckbox;
